export default __webpack_public_path__ + "static/media/degot-screenshot-04.bf99cf96.png";